import RandingStyle7 from "../../randing/RandingStyle7";

function Randing225({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle7
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/225/1.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/225/2.png`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/225/3.png`}
      bottomIMG={`${process.env.REACT_APP_CDN_BASE}/images/225/4.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton4.png`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/225`} // 버튼 색상 파란색ver2 (225)
      addStyle={{ marginTop: 0, width: "117.5%" }}
      companyName="본원"
      privacyCompanyName="열린치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/infocenter.jpg`}
    />
  );
}

export default Randing225;
